<template>
  <div
    class="sidebar-wrapper"
    :class="{
      'sidebar-wrapper-open': isSidebarOpen && !floatingNav,
      'sidebar-wrapper-close': !isSidebarOpen && !floatingNav,
      'floating-sidebar-open': isSidebarOpen && floatingNav,
      'floating-sidebar-close': !isSidebarOpen && floatingNav,
    }"
  >
    <div class="d-flex justify-content-center mt-4 mb-4 position-relative">
      <div
        class="d-flex justify-content-center pb-4"
        style="border-bottom: 1px solid #d9d9d9; width: 84%"
      >
        <img
          v-show="isSidebarOpen"
          src="img/brand/brand_logos/SVG/sense_logo.svg"
          height="52"
          alt="Brand Logo Full"
        />
        <img
          v-show="!isSidebarOpen && !floatingNav"
          src="img/brand/brand_logos/SVG/weavr_logo.svg"
          height="32"
          alt="Brand Logo Minimized"
        />
      </div>
      <div
        class="d-flex justify-content-center align-items-center position-absolute"
        :class="isSidebarOpen ? 'toggler-open' : 'toggler-close'"
        @click="toggleSidebar"
      >
        <img
          v-show="isSidebarOpen"
          src="Icons_SVG/Sidebar Toggle Left.svg"
          alt="left-toggler"
        />
        <img
          v-show="!isSidebarOpen && !floatingNav"
          src="Icons_SVG/Sidebar Toggle Right.svg"
          alt="right-toggler"
        />
      </div>
    </div>
    <div
      @mouseenter="$emit('open-sidebar')"
      @mouseleave="$emit('close-sidebar')"
      style="
        padding-inline: 12px;
        overflow-y: auto;
        height: calc(100vh - 100px);
        padding-bottom: 3rem;
      "
    >
      <div
        v-for="(menuItem, menuIndex) in menuItems"
        :key="menuItem.name"
        v-if="(floatingNav && isSidebarOpen) || !floatingNav"
        @click="setIndex(menuIndex, menuItem)"
        :class="{
          'active-router':
            currentTab == menuIndex &&
            (!menuItem.submenuItems || !isSidebarOpen),
          'menu-list': !menuItem.submenuItems,
          'd-flex justify-content-center align-items-center': !isSidebarOpen,
          'justify-content-start': isSidebarOpen,
          'pl-3': isSidebarOpen && !menuItem.submenuItems,
        }"
      >
        <div
          :class="{
            'd-flex  align-items-center justify-content-start': isSidebarOpen,
            'd-flex flex-column align-items-center': !isSidebarOpen,
          }"
          v-if="!menuItem.submenuItems"
        >
          <img
            :src="require(`../../public/Icons_SVG/${menuItem.name}.svg`)"
            :alt="menuItem.name + '_icon'"
            class="sidebar-icons"
          />
          <router-link :to="menuItem.url">
            <div v-show="isSidebarOpen">
              {{ getTranslatedLabel(menuItem.name) }}
            </div>
          </router-link>
        </div>
        <div v-else style="margin-block: -4px">
          <div
            class="menu-list"
            :class="{ 'pl-3': isSidebarOpen, 'py-2': !isSidebarOpen }"
            style="cursor: default"
          >
            <img
              :src="require(`../../public/Icons_SVG/${menuItem.name}.svg`)"
              :alt="menuItem.name + '_icon'"
              class="sidebar-icons"
            />
            <span v-show="isSidebarOpen">{{
              getTranslatedLabel(menuItem.name)
            }}</span>
          </div>
          <div
            v-show="isSidebarOpen"
            v-for="(submenu, submenuIndex) in menuItem.submenuItems"
            :key="submenu.name"
            class="submenu"
            @click="setSubmenuIndex(menuIndex, submenu, submenuIndex)"
            :class="{
              'active-router':
                currentTab == menuIndex && currentSubmenu == submenuIndex,
            }"
          >
          <div :to="submenu.url" class="router-link" > 
              <div v-show="isSidebarOpen">
                {{ getTranslatedLabel(submenu.name) }}
              </div>
          </div>
          </div>

        </div>
      </div>
      <!-- <router-link to="/connect-your-account" class="tw-cursor-pointer">
        <div
          class="menu-list"
          :class="{ 'pl-3': isSidebarOpen, 'p-3': !isSidebarOpen }"
        >
          <img
            :src="require(`../../public/Icons_SVG/connectAccountIcon.svg`)"
            class="sidebar-icons"
          />
          <span v-show="isSidebarOpen" class="tw-cursor-pointer">Connect Your Account</span>
        </div>
      </router-link> -->
    </div>
    <div v-if="showOverlay" class="pc-menu-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "CustomSidebar",
  props: { menuItems: Array, isSidebarOpen: Boolean },
  data() {
    return {
      currentTab: localStorage.menuIndex,
      currentSubmenu: localStorage.submenuIndex,
      showOverlay: false,
    };
  },

  created() {
    if (localStorage.getItem("reloaded")) {
      localStorage.removeItem("reloaded");
    } else {
      localStorage.setItem("reloaded", "1");
      location.reload();
    }
    if (localStorage.getItem("menuIndex")) {
      this.currentTab = localStorage.menuIndex;
      if (localStorage.getItem("submenuIndex")) {
        this.currentSubmenu = localStorage.submenuIndex;
      }
    } else {
      localStorage.setItem("menuIndex", "0");
    }
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
    floatingNav() {
      if (window.screen.width < 1024) {
        return true;
      } else return;
    },
  },
  mounted() {
    if (localStorage.menuIndex) {
      if (localStorage.submenuIndex) {
        this.setSubmenuIndex(
          localStorage.menuIndex,
          this.menuItems[localStorage.menuIndex].submenuItems[
            localStorage.submenuIndex
          ],
          localStorage.submenuIndex
        );
      } else
        this.setIndex(
          localStorage.menuIndex,
          this.menuItems[localStorage.menuIndex]
        );
    } else {
      if (this.menuItems[0].submenuItems) {
        this.setSubmenuIndex(0, this.menuItems[0].submenuItems[0], 0);
      } else this.setIndex(0, this.menuItems[0]);
    }

    if (window.innerWidth <= 1033 && this.isSidebarOpen) {
      this.showOverlay = true;
    } else {
      this.showOverlay = false;
    }
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    setIndex(tabIndex, item) {
      this.currentTab = tabIndex;
      localStorage.setItem("menuIndex", tabIndex);
      if (
        !item.submenuItems &&
        item.url !== this.$router.history.current.path
      ) {
        this.$router.push(item.url);
      }

      if (window.innerWidth <= 1033 && this.isSidebarOpen) {
        this.toggleSidebar();
      }
    },
    setSubmenuIndex(menuIndex, item, submenuIndex) {
      this.currentTab = menuIndex;
      this.currentSubmenu = submenuIndex;
      localStorage.setItem("submenuIndex", submenuIndex);
      this.$router.push(item.url);
      // if (item.url !== this.$router.history.current.path) {
      //   this.$router.push(item.url);
      // }
    },
    toggleSidebar() {
      this.$emit("toggle-sidebar", this.isSidebarOpen);

      if (window.innerWidth <= 1033) {
        this.showOverlay = !this.isSidebarOpen;
      } else {
        this.showOverlay = false;
      }
    },

    getTranslatedLabel(Sidebarlabel) {
      return (
        (this.translatedLang &&
          this.translatedLang[Sidebarlabel] &&
          this.translatedLang[Sidebarlabel][this.selectedLanguage.key]) ||
        Sidebarlabel ||
        ""
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.slide-enter-active {
  -moz-transition-duration: 0.17s;
  -webkit-transition-duration: 0.17s;
  -o-transition-duration: 0.17s;
  transition-duration: 0.17s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0s;
  -webkit-transition-duration: 0s;
  -o-transition-duration: 0s;
  transition-duration: 0s;
  -moz-transition-timing-function: ease-out;
  -webkit-transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}

.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

.sidebar-wrapper {
  position: fixed !important;
  top: 0;
  height: 100vh !important;
  background: var(--primary_brand) !important;
  z-index: 1002 !important;
  transition: 0.5s;
  text-wrap: nowrap;
}

.floating-sidebar-open {
  width: 60%;
}

.floating-sidebar-close {
  width: 0;
}

.sidebar-icons {
  height: 24px;
  width: 24px;
  line-height: 24px;
  margin-inline: 16px;
}

.menu-list {
  position: relative;
  cursor: pointer;
  padding-block: 12px;
  margin-block: 8px;
  display: flex !important;
}

.menu-list a {
  color: var(--white);
  text-decoration: none;
  cursor: pointer;
  font-size: 16px;
}

.menu-list span {
  color: white;
  font-size: 16px;
  cursor: default;
}

.menu-list:hover,
.submenu:hover {
  color: var(--white) !important;
  background-color: var(--primary_brand-80);
  border-radius: 5px;
}

.submenu {
  margin-left: 4.5rem;
  padding-block: 6px;
  padding-left: 1rem;
  margin-block: 6px;
  cursor: pointer;
}

.submenu a {
  color: var(--white) ;
  text-decoration: none;
  cursor: pointer;
  font-size: 14px;
}

.submenu .router-link {
  color: var(--white) ;
  text-decoration: none;
  cursor: pointer;
  font-size: 14px;
}

.active-router {
  color: var(--primary_brand) !important;
  background-color: var(--background);
  background-color: #f2f6f7;
  font-weight: 600;
  border-radius: 5px;
}

.active-router a {
  color: var(--primary_brand) !important;
}
.active-router .router-link{
  color: var(--primary_brand) !important;
}
.active-router img {
  height: 24px;
  width: 24px;
  margin-inline: 14px;
  filter: brightness(0) saturate(100%) invert(24%) sepia(10%) saturate(6256%)
    hue-rotate(144deg) brightness(97%) contrast(95%);
}

.active-router:hover {
  color: var(--primary_brand) !important;
  background-color: #f2f6f7;
}

.toggler-open {
  position: relative;
  right: -18px !important;
  cursor: pointer;
}

.toggler-open img {
  height: 30px !important;
}

.toggler-close {
  position: relative;
  right: -18px;
  cursor: pointer;
}

.toggler-close img {
  height: 30px !important;
}

.pc-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  background: rgba(0, 0, 0, 0.15);
}

@media (min-width: 320px) and (max-width: 500px) {
  .floating-sidebar-open {
    width: 80%;
  }
}

@media (min-width: 500px) and (max-width: 640px) {
  .floating-sidebar-open {
    width: 70%;
  }
}

@media (min-width: 640px) and (max-width: 768px) {
  .floating-sidebar-open {
    width: 70%;
  }
}

@media (min-width: 768px) and (max-width: 830px) {
  .floating-sidebar-open {
    width: 35%;
  }
}

@media screen and (min-width: 2000px) {
  .sidebar-wrapper-open {
    width: 15% !important;
  }

  .sidebar-wrapper-close {
    width: 7% !important;
  }
}

@media screen and (max-width: 675px) {
  .sidebar-wrapper-open {
    width: 60% !important;
  }

  .sidebar-wrapper-close {
    width: 15% !important;
  }
}

@media (min-width: 676px) and (max-width: 897px) {
  .sidebar-wrapper-open {
    width: 35% !important;
  }

  .sidebar-wrapper-close {
    width: 12% !important;
  }
}

@media (min-width: 898px) and (max-width: 1033px) {
  .sidebar-wrapper-open {
    width: 25% !important;
  }

  .sidebar-wrapper-close {
    width: 8% !important;
  }
}

@media (min-width: 1025px) and (max-width: 1280px) {
  .sidebar-wrapper-open {
    width: 20% !important;
  }

  .sidebar-wrapper-close {
    width: 7% !important;
  }

  .menu-list a,
  span {
    font-size: 14px !important;
  }

  .sidebar-icons {
    width: 21px;
    height: 21px;
    line-height: 21px;
  }
}

@media (min-width: 1280px) and (max-width: 1399px) {
  .sidebar-wrapper-open {
    width: 20% !important;
  }

  .sidebar-wrapper-close {
    width: 7% !important;
  }

  .menu-list a,
  .menu-list span {
    font-size: 14px !important;
  }

  .sidebar-icons {
    width: 21px;
    height: 21px;
    line-height: 21px;
  }
}

@media (min-width: 1400px) and (max-width: 1650px) {
  .sidebar-wrapper-open {
    width: 18% !important;
  }

  .sidebar-wrapper-close {
    width: 7% !important;
  }

  .menu-list a,
  .menu-list span {
    font-size: 14px !important;
  }

  .sidebar-icons {
    width: 21px;
    height: 21px;
    line-height: 21px;
  }
}

@media (min-width: 1651px) {
  .sidebar-wrapper-open {
    width: 15% !important;
  }

  .sidebar-wrapper-close {
    width: 6% !important;
  }

  .menu-list a,
  .menulist span {
    font-size: 16px !important;
  }

  .sidebar-icons {
    width: 24px;
    height: 24px;
    line-height: 24px;
  }
}
</style>
